module.exports = __webpack_public_path__ + "img/unsplash_pElSkGRA2NU.4082e5a6.png";